


























































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  computed,
} from '@vue/composition-api'

import { addMediaItemOccurences } from '@/shared/api'
import CloseButton from '@/components/custom/CloseButton.vue'
import { MediaItem } from '@/shared/types'
export default defineComponent({
  name: 'AddMediaItemOccurences',
  components: {
    CloseButton,
  },
  props: {
    textbook: Object,
    textbookIssue: Object,
    mediaItems: Array,
  },
  setup(props, { emit }) {
    const MediaUploadForm = ref(null)
    const existingOccurences =
      props.mediaItems.length === 1
        ? (props.mediaItems[0] as MediaItem).occurences.filter(
            (occurence) => occurence.textbookIssueId === props.textbookIssue.id
          )
        : []
    const data = reactive({
      valid: true,
      pages: existingOccurences
        .map((occurence) => occurence.page)
        .sort((a: number, b: number) => (a < b ? -1 : 1)),
      deleteOccurences: props.mediaItems.length === 1,
    })

    const rules = reactive({})

    const pagesInIssue = computed((): number[] => {
      if (!props.textbookIssue) {
        return []
      }

      return new Array(props.textbookIssue.numberOfPages)
        .fill(null)
        .map((_: null, index: number) => index + 1)
    })

    const categories = computed(() =>
      props.textbook ? props.textbook.categories : []
    )

    const loadingData = ref(false)

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = MediaUploadForm.value
      if (!form.validate()) {
        return
      }

      loadingData.value = true
      try {
        const mediaItemIds = (props.mediaItems as MediaItem[]).map(
          (mediaItem: MediaItem) => mediaItem.id
        )
        const createdIds = await addMediaItemOccurences(
          props.textbookIssue.id,
          mediaItemIds,
          data.pages,
          data.deleteOccurences
        )

        emit('media-item-occurences-added', createdIds)
        loadingData.value = false
      } catch (error) {
        loadingData.value = false
        throw error
      }
    }

    return {
      ...toRefs(data),
      ...toRefs(rules),
      loadingData,
      MediaUploadForm,
      submit,
      pagesInIssue,
      categories,
    }
  },
})
